import React, { useEffect, useMemo, useState, createContext, useContext } from 'react';
export type Locale = 'fr' | 'en';
type LocaleContextValue = {
  locale: Locale;
  setLocale: (locale: Locale) => void;
};
const LocaleContext = createContext<LocaleContextValue | undefined>(undefined);
export function LocaleProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [locale, setLocale] = useState<Locale>(() => {
    return localStorage.getItem('ssc-locale') === 'en' ? 'en' : 'fr';
  });
  useEffect(() => {
    document.documentElement.lang = locale;
    localStorage.setItem('ssc-locale', locale);
  }, [locale]);
  const value = useMemo(() => ({
    locale,
    setLocale
  }), [locale]);
  return <LocaleContext.Provider value={value} data-id="element-19">{children}</LocaleContext.Provider>;
}
export function useLocale() {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error('useLocale must be used within LocaleProvider');
  }
  return context;
}